<template>
  <a-modal :open="visible" title="编辑查询" @update:open="(a: boolean) => $emit('update:visible', a)" :width="400" @ok="save">
    <a-form :model="formState" autocomplete="off" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" ref="$form">
      <a-form-item label="查询名称" name="name" :rules="[{ required: true, message: '请输入名称' }]">
        <a-input v-model:value.trim="formState.name" ref="$input" />
      </a-form-item>

      <a-form-item label="排序号" name="sort" :rules="[{ required: true, message: '请输入排序码' }]">
        <a-input-number v-model:value="formState.sort" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup lang="ts">
import { FormInstance } from 'ant-design-vue'
import { reactive, ref, watch } from 'vue'

const props = defineProps<{
  visible: boolean,
  saveKey: string,
  query: PageNavigate<OrderQuery>
}>()

const emits = defineEmits(['submit', 'update:visible'])

const formState = reactive({
  name: '',
  sort: 1
})

const $form = ref<FormInstance>()
const $input = ref()

const save = async () => {
  await $form.value?.validate()
  emits('submit', { name: formState.name, sort: formState.sort })
  emits('update:visible', false)
}

watch(() => props.visible, () => {
  if (!props.visible) return
  setTimeout(() => {
    $input.value?.focus()
  }, 100)
  if (props.saveKey === '1') {
    formState.name = '',
    formState.sort = ($app.pageSettings.max(a => a.sort) ?? 1) + 1
    return
  }
  formState.name = props.query.title
  formState.sort = props.query.setting?.sort ?? 1
})


</script>